import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/vacancy/searchApplicant', { params: request })
  },
  find: function (id) {
    return axios.get('/api/vacancy/findApplicant?id=' + id)
  },
  save: function (data) {
    return axios.post('/api/vacancy/saveApplicantAdm', data)
  },  
}